import { ForceErrorAnswer } from '../../../../../types/types';
import Button from '../../../../Button/Button';

export interface RowButtonProps {
  answer: ForceErrorAnswer;
  forceModalAction: (value: string) => void | Promise<void>;
  cancelModalAction: () => void | Promise<void>;
  handleAction: (action: () => void | Promise<void>) => void | Promise<void>;
}

const RowButton = ({
  answer,
  forceModalAction,
  cancelModalAction,
  handleAction,
}: RowButtonProps) => {
  const { label, value } = answer;
  const isCancel = value === '';
  const action = isCancel ? cancelModalAction : () => forceModalAction(value);

  return (
    <Button color={isCancel ? 'light' : 'primary'} onClick={() => handleAction(action)}>
      {label}
    </Button>
  );
};

export default RowButton;
